import { SiteCoreDictionary } from './types';

export const getDescriptionDic = (dictionary: SiteCoreDictionary): { [region: string]: string } => ({
    Region1: dictionary.regionQuestion2Description,
    Region2: dictionary.regionScandinavia,
    Region3: dictionary.regionEuropeText,
    Region4: dictionary.regionAfricaText,
    Region5: dictionary.regionAsiaText,
    Region6: dictionary.regionNorthAmericaText,
    Region7: dictionary.regionSouthAmericaText,
    Region8: dictionary.regionOceaniaText,
});

export const getTitleDic = (dictionary: SiteCoreDictionary): { [region: string]: string } => ({
    Region1: dictionary.regionNorway,
    Region2: dictionary.regionScandinavia,
    Region3: dictionary.regionEurope,
    Region4: dictionary.regionAfrica,
    Region5: dictionary.regionAsia,
    Region6: dictionary.regionNorthAmerica,
    Region7: dictionary.regionSouthAmerica,
    Region8: dictionary.regionOceania,
});
